export function parseMarkdown(moduleObject: ModuleObject): ReadmeSection[] {
    if (!moduleObject || !moduleObject.readme) return []
    const lines = moduleObject.readme.split('\n')
    let result = []
    let currentHeader = ''
    let currentContent = ''

    lines.forEach((line) => {
        const match = line.match(/^#{1,2}\s+(.*)/)

        if (match) {
            if (currentHeader !== '') {
                result.push({
                    header: currentHeader.trim(),
                    content: currentContent.trim(),
                })
            }

            currentHeader = match[1]
            currentContent = ''
        } else {
            currentContent += line + '\n'
        }
    })

    if (currentHeader !== '') {
        result.push({
            header: currentHeader.trim(),
            content: currentContent.trim(),
        })
    }

    return result
}
